module.exports = __webpack_public_path__ + "static/media/deskWhite.d54b4aed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/deskWhite.jpg
// module id = 152
// module chunks = 2